module.exports = __webpack_public_path__ + "static/pmb_map_lock_2_full-9ced872923433ebb1fe8285be6069835.jpg";